import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { ref, reactive, onMounted } from 'vue';
import { getStore } from '@/util/store';
import TeacherDataView from './teacherDataView.vue';
import { getAppAlias, getDeptAuthList, getSchoolList } from '@/api/home.js';
import useUserStore from '@/stores/modules/user';
export default {
  __name: 'DataView',
  setup: function setup(__props) {
    var _useUserStore = useUserStore(),
      setDataViewSchoolId = _useUserStore.setDataViewSchoolId;
    var userInfo = getStore({
      name: 'userInfo'
    });
    var load = ref(true);
    var role = reactive({
      rector: false,
      director: false,
      teacher: false
    });
    getAppAlias('dataView').then(function (res) {
      var result = res.data.data;
      if (result.auth) {
        result.auth.forEach(function (item) {
          switch (item.permission) {
            case 'rector':
              role.rector = true;
              break;
            case 'director':
              role.director = true;
              break;
            case 'teacher':
              role.teacher = true;
              break;
          }
        });
      }
      load.value = false;
    });
    var schoolList = ref([]);
    onMounted(function () {
      var userId = userInfo.id;
      var data = {
        type: 0,
        userId: userId
      };
      getDeptAuthList(data).then(function (res) {
        var list = res.data.data.map(function (v) {
          return {
            schoolId: v.id,
            schoolName: v.name
          };
        });
        schoolList.value = list;
      });
      getSchoolList().then(function (res) {
        var list = res.data.data;
        if (list.length > 0) {
          setDataViewSchoolId(list[0].schoolId);
        }
      });
    });
    return function (_ctx, _cache) {
      var _component_t_swiper_item = _resolveComponent("t-swiper-item");
      var _component_t_swiper = _resolveComponent("t-swiper");
      return _openBlock(), _createBlock(_component_t_swiper, {
        class: "tdesign-demo-block--swiper swiper-container",
        duration: 300,
        interval: 10000,
        navigation: {
          type: 'dots',
          showSlideBtn: 'never'
        },
        showSlideBtn: true,
        autoplay: false
      }, {
        default: _withCtx(function () {
          return [role.rector ? (_openBlock(), _createBlock(_component_t_swiper_item, {
            key: 0,
            class: "swiper-item"
          }, {
            default: _withCtx(function () {
              return [_createVNode(TeacherDataView, {
                role: "rector",
                "school-list": schoolList.value
              }, null, 8, ["school-list"])];
            }),
            _: 1
          })) : _createCommentVNode("", true), role.director ? (_openBlock(), _createBlock(_component_t_swiper_item, {
            key: 1,
            class: "swiper-item"
          }, {
            default: _withCtx(function () {
              return [_createVNode(TeacherDataView, {
                role: "director"
              })];
            }),
            _: 1
          })) : _createCommentVNode("", true), role.teacher ? (_openBlock(), _createBlock(_component_t_swiper_item, {
            key: 2,
            class: "swiper-item"
          }, {
            default: _withCtx(function () {
              return [_createVNode(TeacherDataView, {
                role: "teacher"
              })];
            }),
            _: 1
          })) : _createCommentVNode("", true)];
        }),
        _: 1
      });
    };
  }
};